const topics = [

    {
      title: "Continents & Oceans",
      slug: "continentsandoceans",
      standardNumber: "USI.2",
      description: "The world is made up of seven continents—Africa, Antarctica, Asia, Australia, Europe, North America, and South America—and five major oceans: Pacific, Atlantic, Indian, Arctic, and Southern.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcontinentsandoceans2021.mp4?alt=media&token=dfa953f5-3c7a-4eaa-8324-7c30ad8495ab",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcontinentsandoceans2025song.mp3?alt=media&token=8009685b-ddfb-459c-b393-739b04808f60",
      lyrics: ["(Verse)",
"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",
"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",

"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",
"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",

"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",
"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "Areas",
      slug: "areas",
      standardNumber: "USI.2",
      description: "The United States has distinct landforms including the Coastal Plain, Appalachian Mountains, Interior Lowlands, Great Plains, Rocky Mountains, Basin and Range, and Coastal Range.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fareas2022.mp4?alt=media&token=6c89d23e-dfc3-4e44-84e4-cfe07744924b",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fareas2025song.mp3?alt=media&token=8589a291-a299-4a65-af1f-a0b4f06d5b0c",
      lyrics: ["(Verse)",
"Coastal Plain, low flat land.",
"Coastal Plain, low flat land.",
"Coastal Plain located along the Atlantic Ocean.",

"Appalachian Mountains are highlands",
"From Canada to Alabama.",
"Appalachian Mountains are highlands",
"From Canada to Alabama.",

"Interior Lowlands are flat lands",
"With grassy hills and rivers.",

"Great Plains are flat lands,",
"Elevate when you go west, grasslands.",

"Rocky Mountains, rugged mountains",
"From Alaska almost to Mexico.",
"Rocky Mountains, rugged mountains",
"From Alaska almost to Mexico.",

"Basin and Range contains Death Valley and mountain ranges.",
"Basin and Range is the lowest point in North America.",

"Coastal Range goes from California to Canada.",
"Coastal Range, fertile valleys.",
"Coastal Range, rugged mountains.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "Major Bodies",
      slug: "majorbodies",
      standardNumber: "USI.2",
      description: "Major U.S. bodies of water like rivers, lakes, and oceans supported exploration, transportation, trade, and the growth of cities.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmajorbodies2021.mp4?alt=media&token=9d5bbced-1957-4f33-92d7-36cb727183f9",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmajorbodies2025song.mp3?alt=media&token=94c4f6bd-723b-4bb4-bd0d-f308d7f69a5a",
      lyrics: ["(chorus)",
"Major bodies of water in the United States.",
"Major bodies of water in the United States.",

"(verse)",
"Lewis and Clark explored the Columbia River.",
"The Spanish explored the Colorado River.",
"To get to Mexico the Spanish used the Gulf of Mexico.",
"To get to Mexico the French used the Gulf of Mexico.",
"We transported farm products on the Mississippi River.",
"We transported farm products on the Missouri River.",
"To get to the west we used the Ohio River.",
"To get to the west we used the Ohio River.",

"(chorus)",
"Major bodies of water in the United States.",
"Major bodies of water in the United States.",

"(verse)",
"Cities grew along the Great Lakes,",
"Lake Superior.",
"Cities grew along the Great Lakes,",
"Lake Michigan.",
"Cities grew along the Great Lakes,",
"Lake Huron, Lake Erie and Lake Ontario.",
"The Atlantic Ocean gave a route to the rest of the world.",
"The Pacific Ocean gave a route to the rest of the world.",
"The Atlantic Ocean gave a route to the rest of the world.",
"The Pacific Ocean gave a route to the rest of the world.",

"(chorus)",
"Major bodies of water in the United States.",
"Major bodies of water in the United States.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "Pueblo & Lakota",
      slug: "puebloandlakota",
      standardNumber: "USI.3",
      description: "The Pueblo of the Southwest and the Lakota of the Plains lived in unique homes, farmed, hunted, and expressed their culture through pottery, carvings, and respect for nature.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpuebloandlakota2025.mp4?alt=media&token=a06a95af-f5b3-4199-9165-382a48276536",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpuebloandlakota.mp3?alt=media&token=c33cba83-be7e-421e-ba33-fa5431f9ff9f",
      lyrics: ["(chorus)",
"I’m a Pueblo, I lived in the southwest region.",
"I’m a Pueblo, I lived in the southwest region.",

"(verse1)",
"We lived in buildings and cliffs that were more than one level.",
"We were farmers and hunters,",
"We were farmers and hunters.",
"We lived in buildings and cliffs that were more than one level,",
"And walking was our means of transportation.",

"(chorus)",
"I’m a Lakota, I lived in the plains.",
"I’m a Lakota, I lived in the plains.",

"(verse2)",
"As Lakota, we made carvings and pottery.",
"As Lakota, we built homes called teepees.",
"As Lakota, we were hunters.",
"As Lakota, we were horseman.",
"I am a Lakota and I have respect for nature.",
"I am a Lakota and I have respect for nature.",

"(chorus)",
"I’m a Pueblo, I lived in the southwest region.",
"I’m a Pueblo, I lived in the southwest region.",
"I’m a Lakota, I lived in the plains.",
"I’m a Lakota, I lived in the plains.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "As a Native",
      slug: "asanative",
      standardNumber: "USI.3",
      description: "American Natives used natural, human, and capital resources by fishing, hunting, farming, and making tools, clothing, and canoes.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fasanative2025video.mp4?alt=media&token=490a5691-e474-4891-b5fb-0b819bb81d49",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fasanative2025song.mp3?alt=media&token=e47098bc-0ebf-478d-9a5a-2cffe63f2ee5",
      lyrics: ["(chorus)",
"As an American Native, we fished for food.",
"As an American Native, lots of crops we grew.",
"As an American Native, we hunted for food.",
"We made clothes from plants and the skins of animals.",

"(verse)",
"The fish and the animals were natural resources.",
"The crops that we grew were natural resources.",
"The people who caught the fish were human resources.",
"and the canoes and bows were capital resources.",

"(chorus)",
"As an American Native, we fished for food.",
"As an American Native, lots of crops we grew.",
"As an American Native, we hunted for food.",
"We made clothes from plants and the skins of animals.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "Countries Explored",
      slug: "countriesexplored",
      standardNumber: "USI.4",
      description: "European countries explored for religion, wealth, trade, competition, and resources while facing hardships and exchanging goods and ideas.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcountriesexplored2021.mp4?alt=media&token=0984a99b-8ccc-458d-9b6c-0ad50b9e842c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcountriesexplored2025.mp3?alt=media&token=07bb223e-3e91-4111-b518-09a900f19e7c",
      lyrics: ["(chorus)",
"Countries explored to spread religion.",
"Countries explored for the competition.",
"Countries explored for trade and for gold.",
"Countries explored for resources that’s natural.",

"(verse)",
"During exploration, people starved and caught diseases.",
"During exploration, they had poor maps and navigation.",
"During exploration, they didn’t have proper supplies.",
"During exploration, they didn’t know what lay ahead.",

"(bridge)",
"Explorers exchanged goods with those they encountered.",
"Explorers exchanged ideas with those they encountered.",
"Explorers claimed territories,",
"Explorers claimed territories.",

"(chorus)",
"Countries explored to spread religion.",
"Countries explored for the competition.",
"Countries explored for trade and for gold.",
"Countries explored for resources that’s natural.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "When They Came",
      slug: "whentheycame",
      standardNumber: "USI.4",
      description: "Spanish, English, and French explorers impacted America by spreading Christianity, trading, conquering, enslaving, and starting settlements.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwhentheycame2022.mp4?alt=media&token=b9fbbff5-0b51-4fc1-bbf4-f759fbf22da4",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhentheycame2025song.mp3?alt=media&token=9a542f4a-f670-494e-ac3c-522282d45555",
      lyrics: ["(verse)",
"When the Spanish came to America,",
"they brought Christianity and European diseases.",

"When the Spanish came to America,",
"they conquered Native Americans,",
"they enslaved Native Americans.",

"When the English came to America,",
"they claimed land and started settlements.",

"When the English came to America,",
"they traded with Native Americans,",
"learned things from Native Americans.",

"When the French came to America,",
"they spread religion, the Christian religion.",

"When the French came to America,",
"they set up trading post, they set up trading post.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "West Africa Power",
      slug: "westafricapower",
      standardNumber: "USI.4",
      description: "Between 300 and 1600 A.D. the West African empires of Ghana, Mali, and Songhai gained power by controlling trade.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwestafricapower2021.mp4?alt=media&token=1d986081-d4ac-410c-bd6d-d7a3506ee0f7",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwestafricapower.mp3?alt=media&token=9ee07626-4810-4113-a366-9a74979eac1e",
      lyrics: ["(chorus)",
"In between 300 A.D. and 1600 A.D.",
"Ghana got its power by controlling trade in West Africa.",
"In between 300 A.D. and 1600 A.D.",
"Mali got its power by controlling trade in West Africa.",
"In between 300 A.D. and 1600 A.D.",
"Songhai got its power by controlling trade in West Africa.",

"(verse)",
"The Portuguese would trade metals, clothes,",
"and other things for gold, gold in West Africa.",

"Ghana’s location was perfect, near the Niger River.",
"Mali’s location was perfect, near the Niger River.",
"Songhai’s location was perfect, near the Niger River,",
"near the Niger River.",

"(chorus)",
"In between 300 A.D. and 1600 A.D.",
"Ghana got its power by controlling trade in West Africa.",
"In between 300 A.D. and 1600 A.D.",
"Mali got its power by controlling trade in West Africa.",
"In between 300 A.D. and 1600 A.D.",
"Songhai got its power by controlling trade in West Africa.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    }, 
    {
      title: "Looking For",
      slug: "lookingfor",
      standardNumber: "USI.5",
      description: "European colonies in North America were founded for economic ventures like Jamestown and Georgia or for religious freedom like Plymouth and Pennsylvania.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Flookingfor2021.mp4?alt=media&token=39fd9a3b-27dc-45e8-a2e3-3ee0f42322e7",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Flookingfor.mp3?alt=media&token=14372f2c-c01b-4c03-9ebb-75557487b8b4",
      lyrics: ["(chorus)",
"Colonies were started in North America by Europeans",
"for religious reasons.",
"Colonies were started in North America by Europeans",
"for economic reasons.",

"(verse)",
"Georgia was settled by people looking for economic freedom.",
"Plymouth Colony was settled by people looking for religious freedom.",
"Jamestown was settled by people looking for economic ventures.",
"Pennsylvania was settled by people looking for religious freedom.",

"(chorus)",
"Colonies were started in North America by Europeans",
"for religious reasons.",
"Colonies were started in North America by Europeans",
"for economic reasons.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "Depended On",
      slug: "dependedon",
      standardNumber: "USI.5",
      description: "The New England, Mid-Atlantic, and Southern Colonies each specialized in certain goods like fishing, grains, or cash crops and depended on one another through trade.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdependedon2021.mp4?alt=media&token=b206d29f-f38b-4d53-abc3-061e7ddfbae9",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdependedon2025song.mp3?alt=media&token=55e9ee61-9409-4c61-bb8c-5cd67de561af",
      lyrics: ["(Verse)",
"The New England Colony specialized in fishing,",
"specialized in shipbuilding,",
"and specialized in making naval supplies.",
"They depended on the Mid-Atlantic Colonies for livestock.",
"They depended on the Southern Colonies for tobacco and other crops.",

"The Mid-Atlantic Colony specialized in livestock,",
"specialized in fish,",
"and specialized in grains.",
"They depended on the New England Colonies for metal tools.",
"They depended on the Southern Colonies for rice, cotton, and tobacco.",

"The Southern Colonies specialized in growing rice,",
"specialized in growing tobacco,",
"specialized in growing cotton and indigo.",
"They depended on the New England Colonies for equipment and tools.",
"They depended on the Mid-Atlantic Colonies for grains and livestock.",

"© Smart Board Learning, LLC. All rights reserved."],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "Colonial Times",
      slug: "colonialtimes",
      standardNumber: "USI.5",
      description: "Colonial life in America included large landowners with slaves, farmers relying on family, women limited in rights, and free African Americans working for pay and owning land but unable to vote.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcolonialtimes2021.mp4?alt=media&token=48eeb954-907c-459c-a0a7-4785ccb90b0b",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcolonialtimes.mp3?alt=media&token=0b212d02-3892-4b96-ad94-95dfb02a2992",
      lyrics: ["(verse)",
"During the colonial times in America,",
"large land owners relied on slaves and servants for labor.",

"During the colonial times in America,",
"large land owners had a rich social culture.",

"During the colonial times in America,",
"farmers depended on family members for labor.",

"During the colonial times in America,",
"farmers grew crops that grew best in their region.",

"During the colonial times in America,",
"women worked as homemakers and caretakers.",

"During the colonial times in America,",
"women could not vote and most could not get an education.",

"During the colonial times in America,",
"free African Americans worked for pay but could not vote.",

"During the colonial times in America,",
"free African Americans were able to own land.",

"During the colonial times in America.",
"During the colonial times in America.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "Great Britain & The Colonies",
      slug: "gbandthecolonies",
      standardNumber: "USI.5",
      description: "Great Britain controlled colonial trade, taxed the colonies, enforced laws through governors, and required colonists to obey British rule.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fgreatbritainandthecolonies2021.mp4?alt=media&token=79946c13-329b-4790-885e-67c192896f0c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fgbandthecolonies.mp3?alt=media&token=b152ba53-50a0-4ec0-b561-4f1a8a419032",
      lyrics: ["(chorus)",
"Great Britain controlled the trade in the colonies.",
"Great Britain controlled the trade in the colonies.",

"(verse)",
"Great Britain traded goods for raw materials supplied by the colonies.",
"Great Britain taxed the colonies.",
"Great Britain taxed the colonies.",
"The colonist had to obey British laws.",
"The colonist had to obey British laws.",
"Governors enforced the laws, governors enforced the laws.",
"The King of Great Britain appointed governors for the colonies.",
"The King of Great Britain appointed governors for the colonies.",

"(chorus)",
"Great Britain controlled the trade in the colonies.",
"Great Britain controlled the trade in the colonies.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    
    {
      title: "The Declaration of Independence",
      slug: "thedeclaration",
      standardNumber: "USI.6",
      description: "The Declaration of Independence, written by Thomas Jefferson, explained self-government and declared that all people have rights to life, liberty, and the pursuit of happiness.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthedeclaration2025video.mp4?alt=media&token=5f196d84-24ce-4d49-9fc7-a5e1edf1040f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthedeclaration2025song.mp3?alt=media&token=a3535b3a-c748-41af-be89-0269139b63f8",
      lyrics: ["(Chorus)",
"The Declaration of Independence.",
"The Declaration of Independence.",

"(Verse)",
"All the reasons we have our independence,",
"Was written in The Declaration of Independence.",
"All the ideas we have for self-government,",
"Was written in The Declaration of Independence.",

"All people are created equal.",
"All people have rights to life.",
"All people have rights to liberty,",
"And the pursuit of happiness.",

"Thomas Jefferson was an author,",
"Of The Declaration of Independence.",

"(Chorus)",
"The Declaration of Independence.",
"The Declaration of Independence.",
"The Declaration of Independence.",
"The Declaration of Independence.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    
    {
      title: "Articles",
      slug: "articles",
      standardNumber: "USI.7",
      description: "The Articles of Confederation created the first U.S. constitution with a weak national government, equal state votes, and no power to tax or regulate commerce.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Farticles2025video.mp4?alt=media&token=b8520371-f7b1-4542-8fc3-27d6faccc5db",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Farticles2025song.mp3?alt=media&token=6c495c05-673e-4d8c-8b2b-a932189e23ae",
      lyrics: ["(Chorus)",
"During the American Revolution,",
"The Articles of Confederation was a constitution.",
"During the American Revolution,",
"The Articles of Confederation was a constitution.",

"(Verse)",
"Under the Articles of Confederation",
"we had a weak national government.",
"Under the Articles of Confederation",
"each State had one vote regardless of the State’s size.",
"Under the Articles of Confederation",
"we had no executive branch, we had no judicial branch.",
"Under the Articles of Confederation",
"Congress didn’t have power to tax or regulate commerce.",

"(Chorus)",
"During the American Revolution,",
"The Articles of Confederation was a constitution.",
"During the American Revolution,",
"The Articles of Confederation was a constitution.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "The Constitution",
      slug: "theconstitution",
      standardNumber: "USI.7",
      description: "The Constitution, written in 1787, is the highest law of the United States, creating the government, protecting rights through amendments like the Bill of Rights, and guiding the nation over time.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftheconstitutionvideo2025.mp4?alt=media&token=60be23b0-6432-4d5b-8503-6a99b6380b31",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftheconstitution2025song.mp3?alt=media&token=10bf0430-7e96-494d-944c-7bbbe1f81354",
      lyrics: ["(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 1)",
"The Constitution builds our government, step by step, you know it’s true!",
"It gives us leaders like the president, Congress, and the courts we use.",
"Each state has its own set of laws to guide its people every day,",
"but the U.S. Constitution is the highest, it leads the way!",
"In 1787, the framers made their plan, they made their plan.",
"George Washington, Ben Franklin, and others shaped this land.",
"They added amendments to protect our rights, so we’d be free.",
"And the government must follow them—it’s the law for you and me!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 2)",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"Added in 1791 to help our freedoms grow!",
"Added in 1791 to help our freedoms grow!",
"Thousands of changes were proposed, but only 27 were passed.",
"Thousands of changes were proposed, but only 27 were passed.",
"The Constitution stands the test of time, its strength will always last!",
"The Constitution stands the test of time, its strength will always last!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "First Five",
      slug: "firstfive",
      standardNumber: "USI.7",
      description: "The first five U.S. presidents: Washington, Adams, Jefferson, Madison, and Monroe led important events like the Bill of Rights, Louisiana Purchase, War of 1812, and Monroe Doctrine.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffirstfive2025video.mp4?alt=media&token=35096015-7757-41c6-9844-9f289c9c82b1",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffirstfive2025song.mp3?alt=media&token=30cb6fb7-96d7-42a8-ae81-e453554f27dd",
      lyrics: ["(chorus)",
"United States, first five presidents.",
"United States, first five presidents.",
"United States, first five presidents.",
"United States, first five presidents.",

"(verse)",
"When George Washington was our first president,",
"the Bill of Rights was added to the Constitution.",
"When John Adams was our second president,",
"we were divided into two political parties.",
"When Thomas Jefferson was our third president,",
"he brought Louisiana from France and Lewis & Clark explored new lands.",
"When James Madison was our fourth president,",
"we fought in the War of 1812, we fought in the War of 1812.",
"When James Monroe was our fifth president,",
"he made the Monroe Doctrine, he made the Monroe Doctrine.",

"(chorus)",
"United States, first five presidents.",
"United States, first five presidents.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "America Grew",
      slug: "americagrew",
      standardNumber: "USI.8",
      description: "Between 1801 and 1861 the United States expanded through the Louisiana Purchase, Florida treaty, Texas independence, Oregon Territory split, and California after the Mexican-American War.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Famericagrew2025video.mp4?alt=media&token=a51ccf77-0dbc-419b-b6a1-8365858612da",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Famericagrew2025song.mp3?alt=media&token=90f41d56-7c74-4bf2-9e8c-c4d117e6ab3c",
      lyrics: ["(Chorus)",
"Between 1801 and 1861 The United States grew,", 
"The United States grew.",
"Between 1801 and 1861 The United States grew,", 
"The United States grew.",
"(Verse)",
"The Louisiana Purchase doubled the size of The United States, The United States.",
"Through a treaty, Florida was given by Spain to The United States, The United States.",
"Texas became independent from Mexico to be part of The United States, The United States.",
"The Oregon Territory was split by Great Britain and The United States, The United States.",
"After the Mexican-American War, California became part of The United States, The United States.",
"(Chorus)",
"Between 1801 and 1861 The United States grew,", 
"The United States grew.",
"Between 1801 and 1861 The United States grew,", 
"The United States grew.",
"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    {
      title: "Settlers Moving",
      slug: "settlersmoving",
      standardNumber: "USI.8",
      description: "Between 1801 and 1861 settlers moved west for cheap land, faster transportation, economic opportunities, and the belief in expansion.",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsettlersmoving2025video.mp4?alt=media&token=1ed9a29f-cd2f-4466-9588-c2d4669ced98",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsettlersmoving2025song.mp3?alt=media&token=a3b03e7f-790d-4b0d-b32a-2c1c1f0f3a2c",
      lyrics: ["(chorus)",
"Settlers started to move between 1801 and 1861.",
"Settlers started to move between 1801 and 1861.",

"(verse)",
"Reasons:",
"To find cheap and fertile land",
"with new opportunities that come along with it.",
"Reasons:",
"Faster transportation, rivers and canals.",
"Reasons:",
"Economic opportunities like the California Gold Rush, farming and logging.",
"Reasons:",
"People believed that expansion was good for our country.",

"(chorus)",
"Settlers started to move between 1801 and 1861.",
"Settlers started to move between 1801 and 1861.",

"© Smart Board Learning, LLC. All rights reserved.",],
      gameType: "multipleChoice",
      titleImage: ""
    },
    

];
export default topics;